import { Injectable } from '@angular/core';
import { Subject }    from 'rxjs/Subject';
import { ApiSettingSyncCareSystemService } from './api-call-providers/api-setting-sync-care-system.service';

/*
  Generated class for the SettingSyncCareSystem provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class SettingSyncCareSystemService {
  settingSource = new Subject<any>();
  setting$ = this.settingSource.asObservable();

  postSource = new Subject<any>();
  post$ = this.postSource.asObservable();

  constructor(
    private _apiSettingSyncCareSystemService: ApiSettingSyncCareSystemService,
  ) {
  }

  async load(params: any = {}) {
    this._apiSettingSyncCareSystemService.isLoading = true
    // let _data = await this._dataCacheService.get(COOKIES_CONFIG.DASHBOARD_DATA)
    // if (!_data.isExist()) {
      await this.fetch(params);
    //   return
    // }
    // this._apiSettingSyncCareSystemService.isLoading = false
    // return this.settingSource.next(_data);
  }


  /**
   * ダッシュボードデータのロード
   */
  async fetch(params: any = {}) {
    let res: any = await this._apiSettingSyncCareSystemService.list(params)
    let data = { data: res.data }
    // if (res.expired) {
    //   data = await this._dataCacheService.set(COOKIES_CONFIG.DASHBOARD_DATA, res.data, res.expired)
    // }
    this.settingSource.next(data)
  }

  async loadByPromise(params: any = {}) {
    let res: any = await this._apiSettingSyncCareSystemService.list(params)
    let data = { data: res.data };
    return data;
  }

  /**
   * 更新処理
   */
  async post(params) {
    let res: any = await this._apiSettingSyncCareSystemService.post(params)
    let data = { data: res.data }
    this.postSource.next(data)
  }

}



// WEBPACK FOOTER //
// ./src/providers/setting-sync-care-system.service.ts